import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, vModelSelect as _vModelSelect, withDirectives as _withDirectives, vModelText as _vModelText, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = { class: "flexRow" }
const _hoisted_2 = { class: "col-sm-12" }
const _hoisted_3 = { class: "form-group" }
const _hoisted_4 = { class: "form-group" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("option", { value: "" }, null, -1)
const _hoisted_6 = ["value"]
const _hoisted_7 = { class: "form-group" }
const _hoisted_8 = { class: "form-group" }
const _hoisted_9 = ["disabled"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_localized_text = _resolveComponent("localized-text")!
  const _component_autocomplete = _resolveComponent("autocomplete")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("h4", null, [
      _createVNode(_component_localized_text, {
        localizedKey: "Inserisci i dati per lo storno",
        text: "Inserisci i dati per lo storno"
      })
    ]),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("form", {
        onSubmit: _cache[5] || (_cache[5] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.saveAcquisto && _ctx.saveAcquisto(...args)), ["prevent"]))
      }, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("label", null, [
            _createVNode(_component_localized_text, {
              localizedKey: "Cliente",
              text: "Cliente"
            })
          ]),
          _createVNode(_component_autocomplete, {
            list: _ctx.clientiForDropdown,
            "search-callback": _ctx.searchCb,
            modelValue: _ctx.selectedCliente,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.selectedCliente) = $event)),
            "obj-key": 'name'
          }, null, 8, ["list", "search-callback", "modelValue"])
        ]),
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("label", null, [
            _createVNode(_component_localized_text, {
              localizedKey: "Seleziona l'acquisto",
              text: "Seleziona l'acquisto"
            })
          ]),
          _withDirectives(_createElementVNode("select", {
            class: "form-control",
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.acquistoIdentifier) = $event))
          }, [
            _hoisted_5,
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.acquistiList, (item, i) => {
              return (_openBlock(), _createElementBlock("option", {
                key: i,
                value: item.identifier
              }, _toDisplayString(_ctx.$filters.date(item.createdOn)) + " " + _toDisplayString(item.nomeProdotto) + " - prezzo " + _toDisplayString(item.importo) + " - punti " + _toDisplayString(item.points), 9, _hoisted_6))
            }), 128))
          ], 512), [
            [_vModelSelect, _ctx.acquistoIdentifier]
          ])
        ]),
        _createElementVNode("div", _hoisted_7, [
          _createElementVNode("label", null, [
            _createVNode(_component_localized_text, {
              localizedKey: "Percentuale storno punti (basato sui punti dell'acquisto)",
              text: "Percentuale storno punti (basato sui punti dell'acquisto)"
            })
          ]),
          _withDirectives(_createElementVNode("input", {
            class: "form-control",
            type: "number",
            max: "100",
            min: "0",
            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.percentualePuntiStorno) = $event))
          }, null, 512), [
            [_vModelText, _ctx.percentualePuntiStorno]
          ])
        ]),
        _createElementVNode("div", _hoisted_8, [
          _createElementVNode("label", null, [
            _createVNode(_component_localized_text, {
              localizedKey: "Livello prodotto impostato (livello attuale: {{actualProductLevel}})",
              text: "Livello prodotto impostato (livello attuale: {{actualProductLevel}})",
              object: { actualProductLevel: _ctx.actualProductLevel }
            }, null, 8, ["object"]),
            _createElementVNode("button", {
              type: "button",
              class: "btn btn-sm btn-danger",
              onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.productLevelApplied = null))
            }, [
              _createVNode(_component_localized_text, {
                localizedKey: "Non impostare",
                text: "Non impostare"
              })
            ])
          ]),
          _withDirectives(_createElementVNode("input", {
            class: "form-control",
            type: "number",
            "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.productLevelApplied) = $event))
          }, null, 512), [
            [_vModelText, _ctx.productLevelApplied]
          ])
        ]),
        _createElementVNode("button", {
          type: "submit",
          disabled: !_ctx.acquistoIdentifier,
          class: "btn btn-primary pull-right"
        }, [
          _createVNode(_component_localized_text, {
            localizedKey: "Salva Storno",
            text: "Salva Storno"
          })
        ], 8, _hoisted_9)
      ], 32)
    ])
  ]))
}